import TagManager from 'react-gtm-module'

const tagManagerArgs = {
    gtmId: 'GTM-WBTVRRJ',
}

export const initializeGTM = () => TagManager.initialize(tagManagerArgs);